module.exports = __webpack_public_path__ + "static/img/corten-steel-identification-signs03.7a06ba0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/see-forever/corten-steel-identification-signs03.jpg
// module id = 950
// module chunks = 0